export const navDirections = {
    HOME: '/',
    ERROR: '*',
    LOGIN: '/login',
    MY_PROFILE: '/profile',
    ATTENDANCE: '/attendance',
    ONLINE_CLASS: '/online_class',
    ONLINE_CLASS_SUBJECT: '/online_class/subject',
    ONLINE_CLASS_CHAPTERS: '/online_class/subject/chapters',
    ONLINE_CLASS_VIDEO: '/online_class/subject/chapters/yt-play',
    TIMETABLE: '/timetable',
    ANNOUNCEMENTS: '/announcements',
    STUDY_MATERIALS: '/study_materials',
    EXAMS: '/exams',
    EXAMS_INSTRUCTIONS: '/exams/instructions',
    EXAMS_PAGE: '/exams/page',
    EXAMS_INSTANT_RESULT: '/exams/result/instant',
    EXAM_RESULTS: '/exams/results',
    EXAM_RANK_LIST: '/exams/results/rank_list',
    CONTACT_US: '/contact_us'
}
